(function () {
  var DRAG_THRESHOLD_PX = 10;
  var startX = 0;
  var startY = 0;
  var startTarget = null;

  document.addEventListener(
    'pointerdown',
    function (event) {
      var target = event.target.closest('[data-slide-link]');
      if (!target) {
        startTarget = null;
        return;
      }
      startTarget = target;
      startX = event.clientX;
      startY = event.clientY;
    },
    true
  );

  document.addEventListener(
    'pointerup',
    function (event) {
      if (!startTarget) return;

      var target = event.target.closest('[data-slide-link]');
      if (!target || target !== startTarget) {
        startTarget = null;
        return;
      }

      var dx = Math.abs(event.clientX - startX);
      var dy = Math.abs(event.clientY - startY);

      startTarget = null;

      // If the pointer moved more than the threshold, this was a swipe/drag,
      // not a genuine tap — don't navigate.
      if (dx > DRAG_THRESHOLD_PX || dy > DRAG_THRESHOLD_PX) return;

      var url = target.getAttribute('data-slide-link');
      if (url) window.location.href = url;
    },
    true
  );

  // Keyboard accessibility: Enter/Space activates a focused slide link.
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var target = event.target.closest && event.target.closest('[data-slide-link]');
      if (!target) return;
      event.preventDefault();
      var url = target.getAttribute('data-slide-link');
      if (url) window.location.href = url;
    },
    true
  );
})();
